/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    var openMenu = function (type) {
        closeAllMenus();
        $('#' + type + '-menu-btn').addClass('is-active');
        $('#' + type + '-menu').fadeIn();
    };

    var closeMenu = function (type) {
        $('#' + type + '-menu-btn').removeClass('is-active');
        $('#' + type + '-menu').hide();
    };

    var closeAllMenus = function () {
        closeMenu('main');
        closeMenu('shop');
    };

    var toggleMenu = function (type) {
        $('#' + type + '-menu-btn').click(function (event) {
            event.stopPropagation();
            if ($(this).hasClass('is-active')) {
                closeMenu(type);
            } else {
                openMenu(type);
            }
        });

        $(window).click(function () {
            closeMenu(type);
        });
    };

    var initProductTabs = function () {
        var activeTab = function (id) {
            $('#tabs-contents .inner-content').hide();
            $('#tabs-titles>li').removeClass('active');
            $('#tabs-titles>li>a[href="' + id + '"]').parent('li').addClass('active');
            $(id).fadeIn();
        };

        if (location.hash) {
            activeTab(location.hash);
        } else {
            activeTab('#descrizione');
        }

        $('#tabs-titles>li>a').click(function () {
            var el = $(this).attr('href');
            activeTab(el);
        });
    };

    var initProductVariations = function () {
        var setActive = function (vid, vkey) {
            $('.box-variations .btn').removeClass('selected');
            $('#btn-' + vid).addClass('selected');
            $('.single-price').hide();
            $('#price-' + vid).fadeIn();
            $('#inp-variation-id').val(vid);
            $('#inp-variation-key').val(vkey);
        };

        var el = $('.box-variations .btn:eq(0)');
        var vid = el.data('variation-id');
        var vkey = el.data('variation-key');
        setActive(vid, vkey);

        $('.box-variations .btn').click(function () {
            var vid = $(this).data('variation-id');
            var vkey = $(this).data('variation-id');
            setActive(vid, vkey);
        });
    };

    var initProductQuantity = function () {
        $('.box-quantity .minus').click(function () {
            var qnt = parseInt($('#quantity').text());
            if (qnt > 1) {
                $('#quantity').html(qnt - 1);
                $('#inp-quantity').val(qnt - 1);
            }
        });

        $('.box-quantity .plus').click(function () {
            var qnt = parseInt($('#quantity').text());
            $('#quantity').html(qnt + 1);
            $('#inp-quantity').val(qnt + 1);
        });
    };

    var n = 0;
    var initHomeSlider = function () {
        var totImages = $('#slider img').length;
        setTimeout(function () {
            $('#slider img').fadeOut(1500);
            n = (n < totImages - 1) ? ++n : 0;
            $('#slider img:eq(' + n + ')').fadeIn(1500);
            initHomeSlider();
        }, 3000);
    };

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                toggleMenu('main');
                toggleMenu('shop');
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        'home': {
            init: function () {
                initHomeSlider();
            },
            finalize: function () {

            }
        },
        'single_product': {
            init: function () {
                initProductTabs();
                initProductVariations();
                initProductQuantity();
            },
            finalize: function () {

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    $(document).ready(function () {
        //if is present newsletter modal show it
        $('.toggle-modal.menu-item-object-custom a').click(function () {
            $target = $($(this).attr('href'));
            if ($target.is('.modal')) {
                $target.modal('toggle');
            }
        });

        if ($('#modal-join-newsletter[data-show=true]').length > 0) {
            if (!Cookies.get('show_newsletter_modal')) {
                setTimeout(function () {
                    $('#modal-join-newsletter').modal('show');
                }, 10000);
            }
        }
        $('#modal-join-newsletter').on('shown.bs.modal', function () {
            Cookies.set('show_newsletter_modal', '1', {expires: 1});
        });
    });

})(jQuery); // Fully reference jQuery after this point.
